import {SearchModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {IntegratedInstanceSearchData} from "./integrated-instance-search.data";

@Injectable()
export class IntegratedInstanceSearchModel extends SearchModel<IntegratedInstanceSearchData> {
    constructor(injector: Injector) {
        super(injector, IntegratedInstanceSearchData)
    }
}
